import { AuthenticationProvider } from "@/common/providers/authentication";
import { SignUpRoute } from "@/features/authentication/route";
import PlanSelection from "@/features/payments/containers/plans";
import { Plan } from "@/features/payments/models/plan";
import { ProfileManageMembershipRoute } from "@/features/profile/route";
import { useNavigate } from "react-router-dom";

function JoinTheClub() {
	const navigate = useNavigate();
	const isAuthenticated = AuthenticationProvider.isAuthenticated;

	const onPlanSelected = (plan: Plan) => {
		if (!isAuthenticated) {
			navigate(SignUpRoute, { state: { plan } });
		} else {
			navigate(ProfileManageMembershipRoute, { state: { plan } });
		}
	};

	const titleStyle = {
		background:
			"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
		WebkitBackgroundClip: "text",
		backgroundClip: "text",
		WebkitTextFillColor: "transparent",
	};

	return (
		<PlanSelection
			header={
				<div className="flex flex-col gap-6 text-center">
					<span className="web-heading-h2">
						Join The <span style={titleStyle}>Club</span>
					</span>
					<p className="web-body-b1 text-gray-700">
						Choose from 3 tiers for the greatest member membership rewards
					</p>
				</div>
			}
			className="px-5 py-8 md:px-37 md:py-50"
			onPlanSelected={onPlanSelected}
		/>
	);
}

export default JoinTheClub;
